<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <a v-bind:href="helper.WEB_URL + '/carparkForm'" class="btn btn-rounded btn-info btn-block-xs-only">
            Create New Car Park
          </a>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="pageFilter" 
        filterKey="cityID"
        v-on:filter-data-change="onFilterDataChange" />

      <AppTable
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick"
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

      <CarParkParkAideIDPopup
        ref="carparkIDModal" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import CarParkParkAideIDPopup from "./PageCarParkParkAideIDPopup"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_stateName',
    text: 'State',
  },
  {
    key: '_cityName',
    text: 'City',
  },
  {
    key: 'carparkNum',
    text: 'CP ID',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem['id'];
    }
  },
  {
    key: 'carparkCode',
    text: 'CP Code',
  },
  {
    key: 'name',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.id}">${dataItem.name}</a>`;
    },
  },
  {
    key: 'code1',
    text: 'Snatch Car Park ID',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      return '<a href="#">View</a>';
    },
    table_popup: 'div',
  },
  {
    key: 'bay',
    text: 'Total Bay',
  },
  {
    key: 'isEnable',
    text: 'Is Enable',
    table_custom: helper.tableCustomEnableDisable,
  },
  {
    key: 'createDate',
    text: 'Date Created',
    table_custom: helper.tableCustomDatetime,
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageCarPark",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    CarParkParkAideIDPopup,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park' },
      ],

      PARAM,
      PARAM_MAP,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    // setTimeout(() => this.loadData(), 500)
    this.PARAM_MAP['code1']['table_hide'] = !helper.hasPermission('carpark.cpid', false)
    this.loadState()
  },
  methods: {
    loadState() {
      this.$refs['pageTable'].setTableLoading('Loading state data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/state',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageState = response.data;
          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All City'}, response.data), this.$route.query.cityID);
          this.loadCity();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'state data'));
        });
    },
    loadCity() {
      this.$refs['pageTable'].setTableLoading('Loading state data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/city',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCity = response.data;
          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All City'}, response.data), this.$route.query.cityID);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'city data'));
        });
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading('Loading car park data...');

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      url += '&sort=createDate';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.sort((a, b) => b.createDate - a.createDate);
          response.data.forEach(k => {
            k['_city'] = this.pageCity.find(j => j.id === k.cityID) || {};
            k['_state'] = this.pageState.find(j => j.id === k['_city']['stateID']) || {};
            k['_cityName'] = k['_city'].name || '';
            k['_stateName'] = k['_state'].name || '';
          });
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        })
    },

    getUrl(cityID) {
      let url = helper.SERVER_URL + '/api2';
      if(cityID) {
        url += '/city/' + cityID;
      }
      url += '/carpark/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      helper.redirect(helper.WEB_URL + '/carparkForm');
    },
    onTableDataClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();

      if(tableParameter[tableParameterIndex].key === 'code1') {
        this.$refs['carparkIDModal'].setModalOpen(tableData[tableDataIndex].id);
      } else {
        helper.redirect({ path: helper.WEB_URL + '/carparkForm', query: { carparkID: tableData[tableDataIndex].id }});
      }
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      
      this.$http
        .post(
          this.getUrl(selectedData.cityID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(selectedData.cityID) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageCarPark.vue